import { Info } from 'lucide-react';

const CurrencySelection = ({ currency, setCurrency }) => {
  return (
    <div className="text-center mb-12">
      <h1 className="text-3xl font-bold mb-6 flex justify-center items-center gap-2">
        Start by choosing your evaluation currency
        <Info size={20} className="text-gray-400" />
      </h1>
      <div className="flex justify-center gap-4 flex-wrap">
        {['USD','GBP','EUR'].map((cur) => (
          <button
            key={cur}
            onClick={() => setCurrency(cur)}
            className={`flex items-center gap-2 px-6 py-3 rounded-lg border-2 transition relative ${
              currency === cur
                ? 'bg-gray-800 border-cyan-400 text-white shadow-lg'
                : 'bg-transparent border-gray-700 text-gray-400 hover:border-gray-600'
            }`}
          >
            <img src={`/${cur.toLowerCase()}.png`} alt={cur} className="h-5 w-5" />
            {cur}
            {(cur === 'GBP' || cur === 'EUR') && (
              <span className="absolute -top-2 -right-2 bg-cyan-400 text-gray-900 text-xs px-2 py-0.5 rounded-full font-bold">
                NEW
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CurrencySelection;
